import { render } from "./UploadedDocumentPreview.vue?vue&type=template&id=68350284&scoped=true&ts=true&lang=pug"
import script from "./UploadedDocumentPreview.vue?vue&type=script&lang=ts"
export * from "./UploadedDocumentPreview.vue?vue&type=script&lang=ts"

import "./UploadedDocumentPreview.vue?vue&type=style&index=0&id=68350284&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68350284"]])

export default __exports__